export default __webpack_public_path__ + "static/media/Consider.fd4809f8.svg";